export default "__VITE_ASSET__4d238cc5__"